import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { PaginatedResult, AccountRechargeModel, AccountWithdrawModel, AccountBalanceModel, rechargeEchoPay, WithdrawRequestParams, BillItemModel } from "./interface/balanceInterface"


/** 获取用户余额 */
export async function getAccountBalance(): Promise<AccountBalanceModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account')
}

/** 获取充值账单 */
export async function getRechargeBill(limit: number, offset: number): Promise<PaginatedResult<AccountRechargeModel>> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account/recharge/bill', {
    limit,
    offset
  })
}

/** 获取提现账单 */
export async function getWithdrawBill(limit: number, offset: number): Promise<PaginatedResult<AccountWithdrawModel>> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account/withdraw/bill', {
    limit,
    offset
  })
}

/** 获取使用账单 */
export async function getUsageBill(limit: number, offset: number): Promise<PaginatedResult<BillItemModel>> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account/usage/bill', {
    limit,
    offset
  })
}

/** 微信充值 */
export async function rechargeFromWechat(amount: number): Promise<rechargeEchoPay> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/ums/account/wechat/recharge', {
    totalAmount: amount,
  })
}

/** 支付宝充值 */
export async function rechargeFromAliPay(amount: number): Promise<rechargeEchoPay> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/ums/account/alipay/recharge', {
    totalAmount: amount,
    productCode: 'FAST_INSTANT_TRADE_PAY'
  })
}

/** 微信充值查询 */
export async function getStatusFromWechatRecharge(orderNumber: number, paymentClose?: string): Promise<AccountRechargeModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account/wechat/order/' + orderNumber, {
    paymentClose
  })
}

/** 支付宝充值查询 */
export async function getStatusFromAlipayRecharge(orderNumber: number, paymentClose?: string): Promise<AccountRechargeModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/account/alipay/order/' + orderNumber, {
    paymentClose
  })
}

/** 提现 */
export async function withdraw(withDrawParams: WithdrawRequestParams): Promise<AccountWithdrawModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/ums/account/withdraw', withDrawParams)
}
